'use strict';

exports.__esModule = true;
exports.default = getComponentName;


/* eslint-disable no-undef */
function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/styled-components/lib/utils/getComponentName.js
// module id = ./node_modules/styled-components/lib/utils/getComponentName.js
// module chunks = 5217438866945042000 7356694376651505000 9453687551911655000 13994203391546835000